import { Container } from '@mui/material';
import GlobalStyles from '@mui/material/GlobalStyles';
import clsx from 'clsx';
import React from 'react';

const loginPageGlobalStyles = {
  '*': {
    margin: 0,
    padding: 0,
  },
  html: {
    WebkitFontSmoothing: 'antialiased' as const,
    MozOsxFontSmoothing: 'grayscale' as const,
    height: '100%',
    width: '100%',
  },
  body: {
    height: '100%',
    width: '100%',
  },
  '#root': {
    height: '100%',
    width: '100%',
  },
};

interface LoginPageLayoutProps {
  children?: React.ReactNode;
  className?: string;
}

export const LoginPageLayout: React.FC<LoginPageLayoutProps> = ({
  children,
  className,
}) => {
  return (
    <div
      className={clsx(
        'flex h-full min-h-full justify-center font-["Inter","Helvetica","Arial",sans-serif] [@media(min-height:700px)]:items-center',
        className,
      )}
    >
      <GlobalStyles styles={loginPageGlobalStyles} />
      <Container
        className="max-sm:h-full max-sm:px-0"
        data-test-id="login-page-layout"
      >
        {/* This is gross and ugly but the recommended approach for handling the TS error
         of React.Node is not assignable to NonNullable.. coming from MUI Container
         https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051#issuecomment-449628575 */}
        <>{children}</>
      </Container>
    </div>
  );
};
